import {Outlet, Navigate} from 'react-router-dom';

const ProtectedMyOrganization = ({authorized, defaultMyOrganization}) => {

    return authorized ? <Outlet/> : <Navigate to={`/my-organization/${defaultMyOrganization}`} replace/>

}

export default ProtectedMyOrganization;
